import { create } from "zustand";
import { Task, generateTasks } from "../utils/taskGenerator";

interface TaskState {
  tasks: Task[];
  updateTask: (id: string, updates: Partial<Task>) => void;
}

export const useTasks = create<TaskState>((set) => ({
  tasks: generateTasks(500),
  updateTask: (id, updates) =>
    set((state) => ({
      tasks: state.tasks.map((t) =>
        t.id === id ? { ...t, ...updates } : t
      ),
    })),
}));
